import { useEffect } from 'react';

/**
 * Hook to handle global keyboard shortcuts
 * @param shortcuts - Map of key combination to callback function
 * Supports combinations like "ctrl+n", "ctrl+shift+s", etc.
 */
export function useGlobalShortcuts(
  shortcuts: Record<string, (event: KeyboardEvent) => void>,
) {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Pressing enter in the dropdown of an input for some reason triggers a keydown event with no "key"
      if (!('key' in event)) return;
      // Build a key combination string
      const parts: string[] = [];
      if (event.ctrlKey || event.metaKey) parts.push('ctrl');
      if (event.shiftKey) parts.push('shift');
      if (event.altKey) parts.push('alt');

      // Add the actual key (normalized)
      const key = event.key.toLowerCase();
      parts.push(key);

      const combo = parts.join('+');
      const action = shortcuts[combo];

      if (action) {
        event.preventDefault();
        event.stopPropagation();
        action(event);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [shortcuts]);
}
